import { Directive } from '@angular/core';
import { IPeriodDateRange } from '@fi-shared/fi-time-range-menu/fi-time-range-menu';
import { Observable, Subject } from 'rxjs';
import {debounceTime, filter, takeUntil} from 'rxjs/operators';
import { FiTaskReportDateType } from '@fi-app/task-v2/fi-task-v2-report/fi-task-v2-report-enums';

@Directive()
export abstract class FiReportWidgetDateBase<T> {
    protected abstract defaultTimePeriodType: T;

    private dateRanges: {
        [reportId: number]: IPeriodDateRange<T>;
    } = {};
    private _dateRangeChanged$ = new Subject<number>();

    subscribeOnDateRangeChanged(reportId: number, ngOnDestroy$: Observable<void>, callback: () => void) {
        this._dateRangeChanged$
            .pipe(
                takeUntil(ngOnDestroy$),
                filter((id) => reportId === id),
                //debounceTime(100),
            )
            .subscribe((reportId) => {
                callback();
            });
    }

    setNewDateRange(reportId: number, dateRange: IPeriodDateRange<T>): void {
        this.dateRanges[reportId] = dateRange;
        this._dateRangeChanged$.next(reportId);
    }

    getDateRange(reportId: number): IPeriodDateRange<T> {
        return (
            this.dateRanges[reportId] ?? {
                TimePeriodType: this.defaultTimePeriodType,
            }
        );
    }

    resetDateRange(reportId: number) {
        delete this.dateRanges[reportId];
    }
}
